import * as React from "react";
import type { SVGProps } from "react";
const SvgMagazine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22h-.015a.966.966 0 0 1-.355-.07c-2.66-1.06-5.6-1.06-8.26 0-.31.12-.66.08-.93-.1-.27-.19-.44-.5-.44-.83V7a1 1 0 0 1 .63-.93A7.854 7.854 0 0 1 4 5.673V3a.992.992 0 0 1 1.19-.98c2.148.417 4.542 1.77 6.81 3.843 2.268-2.075 4.662-3.435 6.81-3.843A.992.992 0 0 1 20 3v2.673c.445.094.898.208 1.37.397A1 1 0 0 1 22 7v14a.999.999 0 0 1-1.37.93c-2.66-1.06-5.6-1.06-8.26 0a1.016 1.016 0 0 1-.356.07H12Zm8-5.5c0 .48-.34.89-.81.98-1.035.201-2.214.769-3.496 1.675 1.444-.09 2.9.062 4.306.455V16.5Zm-7 2.22c1.79-1.52 3.46-2.52 5-3V4.32c-1.59.59-3.32 1.74-5 3.34v11.06Zm-2 0V7.66c-1.68-1.6-3.41-2.75-5-3.34v11.4c1.54.48 3.21 1.48 5 3Zm-7 .89a13.003 13.003 0 0 1 4.306-.455c-1.282-.906-2.461-1.474-3.496-1.675A.997.997 0 0 1 4 16.5v3.11Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMagazine;
